export default "__VITE_ASSET__B9Hax4iD__"